import React from 'react';
import { dummyData } from '../dummy';

export const SameItemPouchList = () => {
    return (
        <div className="w-full h-full flex flex-col items-start justify-center py-5">
            <div>같은 제품이 포함된 파우치</div>
            <div className="w-full h-full overflow-x-auto flex gap-4">
                {dummyData.sameItemInPouch.map((item: any) => (
                    <div key={item.id} className="w-full h-full flex flex-col items-start justify-center py-5">
                        <img src={item.thumbnail} alt={'pouch_thumbnail'} />
                        <div className="text-sm text-black/60">{item.nickname} </div>
                        <div className="line-clamp-2 font-bold">{item.title} </div>
                        <div className="text-sm text-black/60">{item.scrap} </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
